import Vue from 'vue'
import { i18n, setLocale } from './i18n.js'
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue'
import "focus-visible"

import './styles/custom.scss'
import App from './App.vue'
import VeeValidate from 'vee-validate'
import router from './router'
import VueResource from 'vue-resource'
import VueErrorDisplay from 'vue-error-display'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faMinus, faPlus, faEdit, faArrowLeft, faCopy, faTrashAlt,faChevronRight, faChevronDown, faChevronLeft, faCaretRight, faSearchMinus, faSearchPlus, faCog, faQuestionCircle, faExclamationTriangle, faFileDownload } from '@fortawesome/free-solid-svg-icons'


import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { store } from './store'
import { authContext } from "@/auth";

import 'svelte-drag-drop-touch'

library.add(faChevronDown)
library.add(faChevronLeft)
library.add(faArrowLeft)
library.add(faChevronRight)
library.add(faTrashAlt)
library.add(faMinus)
library.add(faPlus)
library.add(faCopy)
library.add(faEdit)
library.add(faCaretRight)
library.add(faSearchMinus)
library.add(faSearchPlus)
library.add(faCog)
library.add(faQuestionCircle)
library.add(faExclamationTriangle)
library.add(faFileDownload)

// window.onload = init()

Vue.config.productionTip = false

Vue.use(VueResource)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueErrorDisplay)
Vue.use(VeeValidate, { inject: false, fieldsBagName: 'formFields' })
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.prototype.$authContext = authContext

async function init () {
  await authContext.initialize((url) => router.replace(url));

  if (!authContext.isAuthenticated) {
    await authContext.login();
  } else {

    await setLocale(authContext.user.locale)
    new Vue({
      router,
      store,
      i18n: i18n,
      render: h => h(App)
    }).$mount('#app')
  }
}


init()
